<template>
  <div
    class="onboarding-users-list-page px-6 px-xs-0 pt-6"
    v-infinite-scroll="loadList"
    :infinite-scroll-disabled="loading"
    infinite-scroll-distance="100"
  >
    <v-simple-table>
      <thead>
        <tr>
          <th></th>
          <th class="text-left">Name</th>
          <th class="text-left">Email</th>
          <th class="text-left">Phone number</th>
          <th class="text-left">Date Joined</th>
          <th class="text-left">Date Registered</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(user, index) in users"
          :key="index"
          class="clickable"
          @click="
            user &&
              $router.push({ name: 'user.details', params: { id: user.id } })
          "
        >
          <td class="py-3 pl-0">
            <user-avatar :avatar="user.avatar" size="36" />
          </td>
          <td>{{ user.full_name }}</td>
          <td>{{ user.email }}</td>
          <td>
            {{ user.phone_number ? '+' + user.phone_number : '' }}
          </td>
          <td>{{ user.addedDate }}</td>
          <td>{{ user.registeredDate }}</td>
        </tr>
        <tr v-if="loading">
          <td class="py-3 pl-0">
            <v-skeleton-loader class="avatar-loading--36" type="avatar" />
          </td>
          <td class="pl-0">
            <v-skeleton-loader type="list-item" />
          </td>
          <td class="pl-0">
            <v-skeleton-loader type="list-item" />
          </td>
          <td class="pl-0">
            <v-skeleton-loader type="list-item" />
          </td>
          <td class="pl-0">
            <v-skeleton-loader type="list-item" />
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import { mapState, mapActions, mapMutations } from 'vuex'
import {
  mdiDotsVertical,
  mdiUnfoldMoreHorizontal,
  mdiMagnify,
  mdiAccountCircleOutline,
  mdiChevronRight
} from '@mdi/js'
import UserAvatar from '@/components/UserAvatar'
import infiniteScroll from 'vue-infinite-scroll'

export default {
  name: 'UnverifiedUsersPage',
  props: ['isSearching', 'searchKey'],
  directives: {
    infiniteScroll
  },

  components: { UserAvatar },

  data() {
    return {
      loading: false,
      showProfile: false,
      selectedProfile: null,
      icons: {
        settings: mdiDotsVertical,
        sort: mdiUnfoldMoreHorizontal,
        search: mdiMagnify,
        view: mdiAccountCircleOutline,
        arrow: mdiChevronRight
      }
    }
  },

  computed: {
    ...mapState({
      users: state => state.user.list.unverified,
      listMeta: state => state.user.listMeta.unverified
    }),

    paginationLength() {
      return (this.listMeta.total / this.listMeta.per_page) | 0
    },

    userType() {
      return this.$route.name.split('.')[1]
    }
  },

  created() {
    this.clearUsers(this.userType)
    this.fetchUsers()
  },

  methods: {
    ...mapMutations({
      clearUsers: 'user/clearUserList'
    }),

    ...mapActions({
      getUsers: 'user/getUsers'
    }),

    search: debounce(function() {
      this.clearUsers(this.userType)
      this.fetchUsers()
    }, 600),

    loadList() {
      if (this.listMeta.current_page < this.listMeta.last_page) {
        this.fetchUsers(this.listMeta.current_page + 1)
      }
    },

    async fetchUsers(page = 1) {
      if (this.loading) return

      let params = { page }

      params.filter = {
        search: this.searchKey,
        type: 'unverified'
      }

      this.loading = true
      await this.getUsers(params)
      this.loading = false
    },

    showProfileDialog(profile) {
      this.selectedProfile = profile
      this.showProfile = true
    }
  }
}
</script>
